module.exports = __webpack_public_path__ + "img/dart.9c1fc074.svg";